import { BaseMapper, CURRENCY_CODE, getCurrencySymbol } from '@ps/utils';

import { AllBuyerSettingsDto, CompanySettingsDto } from '../dtos/settings.dto';
import { AllBuyerSettings, CompanySettings } from '../../models/settings.model';

// Inbound mapper — maps API response DTOs to domain models.
const DEFAULT_CURRENCY = CURRENCY_CODE.US;

export class SettingsMapper extends BaseMapper<
  AllBuyerSettingsDto,
  AllBuyerSettings
> {
  public fromDto(data: AllBuyerSettingsDto): AllBuyerSettings {
    const {
      clickBal,
      cmp,
      enablePriceRecomendation,
      enableUrlTranfrmUsr,
      incl_excl,
      overridCmp,
      supplierAccordian,
      uniqBuyerEntryLink,
    } = data;

    return {
      ...data,
      clickBalance: clickBal,
      company: cmp,
      enablePriceRecommendation: enablePriceRecomendation,
      enableUrlTransformUser: enableUrlTranfrmUsr,
      includeExclude: incl_excl,
      overrideCompany: overridCmp,
      supplierAccordion: supplierAccordian,
      uniqueBuyerEntryLink: uniqBuyerEntryLink,
    };
  }

  public fromCompanyDto(data: CompanySettingsDto[]): CompanySettings | null {
    if (!data.length) return null;

    const { id, fx, generateInvoice, multiBuyerCompanies } = data[0];
    return {
      id,
      fx,
      currencySymbol: getCurrencySymbol(fx || DEFAULT_CURRENCY),
      generateInvoice: generateInvoice,
      multiBuyerCompanies: multiBuyerCompanies || [],
    };
  }
}
